import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/warning.svg'


const _hoisted_1 = { class: "w-full flex items-end justify-end" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "none",
    d: "M0 0h24v24H0z"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mb-3",
  width: "80"
}, null, -1)
const _hoisted_5 = { class: "w-full text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Are you sure you want to reject this candidate?", -1)
const _hoisted_7 = { class: "w-full mt-8 flex flex-col justify-center text-left" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary font-semibold mb-2" }, "Reason:", -1)
const _hoisted_9 = {
  key: 0,
  class: "mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_Button = _resolveComponent("Button")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, { visible: _ctx.showModal }, {
    close: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
          class: "flex flex-col hover:bg-gray-200 p-1 hover:text-red-400 rounded-full cursor-pointer"
        }, _hoisted_3)
      ])
    ]),
    thumbnail: _withCtx(() => [
      _hoisted_4
    ]),
    "alert-text": _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_v_select, {
            modelValue: _ctx.reasonSelected,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.reasonSelected) = $event)),
            options: _ctx.optionsRejected,
            label: "id",
            placeholder: "Select a reason..."
          }, null, 8, ["modelValue", "options"]),
          _createElementVNode("div", null, [
            (_ctx.otherReason)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reason) = $event)),
                    label: "Write here",
                    rows: "4",
                    className: "resize-none pt-5 pb-2 pl-4 pr-10 block w-full px-0 mt-0 bg-transparent border-2 rounded-lg border-solid appearance-none focus:outline-none focus:ring-0 focus:border-gray-200 border-gray-200 bg-gray-100",
                    placeholder: "Write reasons here",
                    name: "reason"
                  }, null, 512), [
                    [_vModelText, _ctx.reason]
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    actions: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "Cancel",
        variant: "outlined",
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.confirmationModal.tell(false)), ["prevent"]))
      }),
      _createVNode(_component_Button, {
        label: "Reject this candidate",
        variant: "contained",
        disabled: _ctx.disabled || _ctx.isLoading,
        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.confirmationModal.tell(true)), ["prevent"]))
      }, null, 8, ["disabled"])
    ]),
    _: 1
  }, 8, ["visible"]))
}